import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import {
  adminRoute,
  publicAdminRoutes,
  privateAdminRoutes,
  adminRouteAbsolute,
  publicUserRoutes,
} from "./utils/constants/route";
import { AdminMainLayout } from "./layouts";
import { ToastContainer } from "react-toastify";
import Auth from "./layouts/admin/auth/Auth";
import { StorageEnum } from "./utils/enum";
import { PaymentSuccess } from "./pages";

const RootRedirect = () => {
  const accessToken = localStorage.getItem(StorageEnum.ACCESS_TOKEN);
  
  if (accessToken) {
    return <Navigate to={adminRouteAbsolute.dashboard} replace />;
  } else {
    return <Navigate to={adminRouteAbsolute.login} replace />;
  }
};

type Props = {};

const App = (props: Props) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        
        {/* Public routes (no authentication required) */}
        <Route path="/payment-success" element={<PaymentSuccess />} />
        
        {/* Public user routes */}
        {publicUserRoutes.map((route, index) => {
          const Page = route.component || "";
          return (
            <Route key={index} path={route.path} element={<Page />} />
          );
        })}
        
        {/* Admin public route */}
        <Route path={adminRoute.base} element={<Auth />}>
          {publicAdminRoutes.map((route, index) => {
            const Page = route.component || "";
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>
        {/* Private route */}
        <Route path={adminRoute.base} element={<AdminMainLayout />}>
          {privateAdminRoutes.map((route, index) => {
            const Page = route.component || "";
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>
      </Routes>
      <ToastContainer newestOnTop autoClose={5000} theme="light" limit={1} />
    </BrowserRouter>
  );
};

export default App;
